import { toast } from 'sonner';
import { ApiValidationError } from '../types/auth';

export { toast };

/** Show a success toast from `location.state.successMessage`, if present. */
export const toastRouteSuccess = (state: unknown): boolean => {
  const message = (state as { successMessage?: string } | null | undefined)?.successMessage;
  if (!message) return false;
  toast.success(message);
  return true;
};

/** Clear router location state after consuming navigation messages. */
export const clearRouteState = () => {
  window.history.replaceState({}, document.title);
};

/** Toast API/action errors; returns false for validation errors (keep inline field errors). */
export const toastApiError = (err: unknown, fallback: string): boolean => {
  if (err instanceof ApiValidationError) return false;
  toast.error(err instanceof Error ? err.message : fallback);
  return true;
};
